export const circularEconomyDocuments = [
  {
    id: 1,
    title:
      'Commissin Recommendation (EU) 2023/2585 of 6 October 2023 on improving the rate of return of used and waste mobile phones, tablets and laptops',
    topic: 'Electrical and electronic waste',
    category: 'Recommendations & Soft Law',
    website: 'eur-lex.europa.eu',
    url: 'https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=OJ%3AL_202302585'
  },
  {
    id: 2,
    title: 'Recommendations for EU and national policy makers to accelerate the circular transition in cities',
    topic: 'Construction and demolition waste',
    category: 'Recommendations & Soft Law',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/recommendations-eu-and-national-policy-makers-accelerate-circular-transition-cities'
  },
  {
    id: 3,
    title:
      'COMMUNICATION FROM THE COMMISSION TO THE EUROPEAN PARLIAMENT, THE COUNCIL, THE EUROPEAN ECONOMIC AND SOCIAL COMMITTEE AND THE COMMITTEE OF THE REGIONS Closing the loop - An EU action plan for the Circular Economy',
    topic: 'Circular Economy',
    category: 'Policy & Strategic Frameworks',
    website: 'eur-lex.europa.eu',
    url: 'https://eur-lex.europa.eu/legal-content/EN/TXT/?qid=1453384154337&uri=CELEX:52015DC0614'
  },
  {
    id: 4,
    title:
      'Communication from the Commission to the European Parliament and the Council - The raw materials initiative : meeting our critical needs for growth and jobs in Europe {SEC(2008) 2741}',
    topic: 'Raw materials',
    category: 'Policy & Strategic Frameworks',
    website: 'www.eur-lex.europa.eu',
    url: 'https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=CELEX:52008DC0699'
  },
  {
    id: 5,
    title:
      'A sustainable bioeconomy for Europe Strengthening the connection between economy, society and the environment : updated bioeconomy strategy',
    topic: 'Sustainability',
    category: 'Policy & Strategic Frameworks',
    website: 'op.europa.eu',
    url: 'https://op.europa.eu/en/publication-detail/-/publication/edace3e3-e189-11e8-b690-01aa75ed71a1/language-en'
  },
  {
    id: 6,
    title:
      'COMMUNICATION FROM THE COMMISSION TO THE EUROPEAN PARLIAMENT, THE COUNCIL, THE EUROPEAN ECONOMIC AND SOCIAL COMMITTEE AND THE COMMITTEE OF THE REGIONS A sustainable Bioeconomy for Europe: Strengthening the connection between economy, society and the environment',
    topic: 'Sustainability',
    category: 'Policy & Strategic Frameworks',
    website: 'eur-lex.europa.eu',
    url: 'https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=CELEX:52018DC0673'
  },
  {
    id: 7,
    title:
      'COMMUNICATION FROM THE COMMISSION TO THE EUROPEAN PARLIAMENT, THE EUROPEAN COUNCIL, THE COUNCIL, THE EUROPEAN ECONOMIC AND SOCIAL COMMITTEE AND THE COMMITTEE OF THE REGIONS The European Green Deal',
    topic: 'Circular Economy',
    category: 'Policy & Strategic Frameworks',
    website: 'eur-lex.europa.eu',
    url: 'https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=CELEX:52019DC0640'
  },
  {
    id: 8,
    title:
      'COMMUNICATION FROM THE COMMISSION TO THE EUROPEAN PARLIAMENT, THE COUNCIL, THE EUROPEAN ECONOMIC AND SOCIAL COMMITTEE AND THE COMMITTEE OF THE REGIONS A new Circular Economy Action Plan For a cleaner and more competitive Europe',
    topic: 'Circular Economy',
    category: 'Policy & Strategic Frameworks',
    website: 'eur-lex.europa.eu',
    url: 'https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=CELEX%3A52020DC0098'
  },
  {
    id: 9,
    title: 'The Just Transition Mechanism: making sure no one is left behind',
    topic: 'Circular Economy',
    category: 'Policy & Strategic Frameworks',
    website: 'commission.europa.eu',
    url:
      'https://commission.europa.eu/strategy-and-policy/priorities-2019-2024/european-green-deal/finance-and-green-deal/just-transition-mechanism_en'
  },
  {
    id: 10,
    title:
      'COMMUNICATION FROM THE COMMISSION TO THE EUROPEAN PARLIAMENT, THE COUNCIL, THE EUROPEAN ECONOMIC AND SOCIAL COMMITTEE AND THE COMMITTEE OF THE REGIONS EU Strategy for Sustainable and Circular Textiles',
    topic: 'Fashion, textile',
    category: 'Policy & Strategic Frameworks',
    website: 'eur-lex.europa.eu',
    url: 'https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=CELEX%3A52022DC0141'
  },
  {
    id: 11,
    title: 'Environment Action Programme to 2030',
    topic: 'Climate, Environment',
    category: 'Policy & Strategic Frameworks',
    website: 'environment.ec.europa.eu',
    url: 'https://environment.ec.europa.eu/strategy/environment-action-programme-2030_en'
  },
  {
    id: 12,
    title:
      'COMMUNICATION FROM THE COMMISSION TO THE EUROPEAN  PARLIAMENT, THE COUNCIL, THE EUROPEAN ECONOMIC AND SOCIAL  COMMITTEE AND THE COMMITTEE OF THE REGIONS A new Circular Economy Action Plan For a cleaner and more competitive Europe',
    topic: 'Circular Economy',
    category: 'Policy & Strategic Frameworks',
    website: 'eur-lex.europa.eu',
    url:
      'https://eur-lex.europa.eu/resource.html?uri=cellar:9903b325-6388-11ea-b735-01aa75ed71a1.0017.02/DOC_1&format=PDF'
  },
  {
    id: 13,
    title: 'European Green Deal',
    topic: 'Climate, Environment',
    category: 'Policy & Strategic Frameworks',
    website: 'commission.europa.eu',
    url:
      'https://commission.europa.eu/strategy-and-policy/priorities-2019-2024/story-von-der-leyen-commission/european-green-deal_en'
  },
  {
    id: 14,
    title: '8th Environment Action Programme to 2030',
    topic: 'Climate, Environment',
    category: 'Policy & Strategic Frameworks',
    website: 'environment.ec.europa.eu',
    url: 'https://environment.ec.europa.eu/strategy/environment-action-programme-2030_en'
  },
  {
    id: 15,
    title: 'Zero Pollution Action Plan',
    topic: 'Climate, Environment',
    category: 'Policy & Strategic Frameworks',
    website: 'environment.ec.europa.eu',
    url: 'https://environment.ec.europa.eu/strategy/zero-pollution-action-plan_en'
  },
  {
    id: 16,
    title: 'Clean Industrial Deal',
    topic: 'Climate, Environment',
    category: 'Policy & Strategic Frameworks',
    website: 'commission.europa.eu',
    url: 'https://commission.europa.eu/topics/competitiveness/clean-industrial-deal_en'
  },
  {
    id: 17,
    title: 'Just Transition Mechanism',
    topic: 'Climate, Environment',
    category: 'Policy & Strategic Frameworks',
    website: 'commission.europa.eu',
    url:
      'https://commission.europa.eu/strategy-and-policy/priorities-2019-2024/european-green-deal/finance-and-green-deal/just-transition-mechanism_en'
  },
  {
    id: 18,
    title: 'EU Strategy for Sustainable and Circular Textiles',
    topic: 'Fashion, textile',
    category: 'Policy & Strategic Frameworks',
    website: 'environment.ec.europa.eu',
    url: 'https://environment.ec.europa.eu/strategy/textiles-strategy_en'
  },
  {
    id: 19,
    title: 'Plastics Strategy (European Strategy for Plastics in a Circular Economy)',
    topic: 'Plastic waste',
    category: 'Policy & Strategic Frameworks',
    website: 'environment.ec.europa.eu',
    url: 'https://environment.ec.europa.eu/strategy/plastics-strategy_en'
  },
  {
    id: 20,
    title: 'Construction Products and Sustainable Built Environment Framework',
    topic: 'Construction and demolition waste',
    category: 'Policy & Strategic Frameworks',
    website: 'www.europarl.europa.eu',
    url:
      'https://www.europarl.europa.eu/legislative-train/theme-a-european-green-deal/file-strategy-for-a-sustainable-built-environment'
  },
  {
    id: 21,
    title: 'EU Bioeconomy Strategy (updated 2018)',
    topic: 'Food waste, bio waste',
    category: 'Policy & Strategic Frameworks',
    website: 'environment.ec.europa.eu',
    url: 'https://environment.ec.europa.eu/strategy/bioeconomy-strategy_en'
  },
  {
    id: 22,
    title: 'European Innovation Partnership (EIP) on Raw Materials',
    topic: 'Raw materials',
    category: 'Policy & Strategic Frameworks',
    website: 'single-market-economy.ec.europa.eu',
    url: 'https://single-market-economy.ec.europa.eu/sectors/raw-materials/eip_en'
  },
  {
    id: 23,
    title:
      'COMMUNICATION FROM THE COMMISSION TO THE EUROPEAN  PARLIAMENT, THE COUNCIL, THE EUROPEAN ECONOMIC AND SOCIAL  COMMITTEE AND THE COMMITTEE OF THE REGIONS RESourceEU Action Plan',
    topic: 'Raw materials',
    category: 'Policy & Strategic Frameworks',
    website: 'single-market-economy.ec.europa.eu',
    url: 'https://single-market-economy.ec.europa.eu/document/download/01c448d6-dc93-40d7-9afe-4c2af448d00c_en'
  },
  {
    id: 24,
    title:
      'COMMUNICATION FROM THE COMMISSION TO THE EUROPEAN PARLIAMENT, THE COUNCIL, THE EUROPEAN ECONOMIC AND SOCIAL COMMITTEE AND THE COMMITTEE OF THE REGIONS Innovation for a sustainable Future - The Eco-innovation Action Plan (Eco-AP)',
    topic: 'Sustainability',
    category: 'Policy & Strategic Frameworks',
    website: 'eur-lex.europa.eu',
    url: 'https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=CELEX%3A52011DC0899'
  },
  {
    id: 25,
    title: 'Green Public Procurement Strategic Framework',
    topic: 'Green Procurement',
    category: 'Policy & Strategic Frameworks',
    website: 'green-forum.ec.europa.eu',
    url: 'https://green-forum.ec.europa.eu/green-business/green-public-procurement_en'
  },
  {
    id: 26,
    title: 'Ecodesign for Sustainable Products Regulation',
    topic: 'Ecodesign',
    category: 'Policy & Strategic Frameworks',
    website: 'commission.europa.eu',
    url:
      'https://commission.europa.eu/energy-climate-change-environment/standards-tools-and-labels/products-labelling-rules-and-requirements/ecodesign-sustainable-products-regulation_en'
  },
  {
    id: 27,
    title:
      'Commission Notice – Commission guidelines to facilitate the harmonised application of provisions on the removability and replaceability of portable batteries and LMT batteries in Regulation (EU) 2023/1542',
    topic: 'Battery waste',
    category: 'Guidance & Implementation Support',
    website: 'www.eur-lex.europa.eu',
    url: 'www.eur-lex.europa.eu'
  },
  {
    id: 28,
    title: 'Circular economy Monitoring framework',
    topic: 'Climate, Environment',
    category: 'Guidance & Implementation Support',
    website: 'ec.europa.eu',
    url: 'https://ec.europa.eu/eurostat/web/circular-economy/monitoring-framework'
  },
  {
    id: 29,
    title: 'EU Ecolabel',
    topic: 'Sustainability',
    category: 'Guidance & Implementation Support',
    website: 'environment.ec.europa.eu',
    url: 'https://environment.ec.europa.eu/topics/circular-economy-topics/eu-ecolabel_en'
  },
  {
    id: 30,
    title: 'Eco-Management and Audit Scheme (EMAS)',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'green-forum.ec.europa.eu',
    url: 'https://green-forum.ec.europa.eu/green-business/emas_en'
  },
  {
    id: 31,
    title: 'Eco-Innovation action plan',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'green-forum.ec.europa.eu',
    url: 'https://green-forum.ec.europa.eu/eco-innovation_en'
  },
  {
    id: 32,
    title: 'Environmental Footprint Methods',
    topic: 'Climate, Environment',
    category: 'Guidance & Implementation Support',
    website: 'green-forum.ec.europa.eu',
    url: 'https://green-forum.ec.europa.eu/green-business/environmental-footprint-methods_en'
  },
  {
    id: 33,
    title: 'European Circular Economy Stakeholder Platform',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en'
  },
  {
    id: 34,
    title: 'Green Public Procurement',
    topic: 'Green Procurement',
    category: 'Guidance & Implementation Support',
    website: 'green-forum.ec.europa.eu',
    url: 'https://green-forum.ec.europa.eu/green-business/green-public-procurement_en'
  },
  {
    id: 35,
    title: 'Ecodesign for sustainable products implementation',
    topic: 'Ecodesign',
    category: 'Guidance & Implementation Support',
    website: 'green-forum.ec.europa.eu',
    url: 'https://green-forum.ec.europa.eu/implementing-ecodesign-sustainable-products-regulation_en'
  },
  {
    id: 36,
    title: 'European framework for sustainable buildings',
    topic: 'Construction and demolition waste',
    category: 'Guidance & Implementation Support',
    website: 'green-forum.ec.europa.eu',
    url: 'https://green-forum.ec.europa.eu/green-business/levels_en'
  },
  {
    id: 37,
    title: 'Policy and strategy for raw materials',
    topic: 'Raw materials',
    category: 'Guidance & Implementation Support',
    website: 'single-market-economy.ec.europa.eu',
    url: 'https://single-market-economy.ec.europa.eu/sectors/raw-materials/policy-and-strategy-raw-materials_en'
  },
  {
    id: 38,
    title: 'The European innovation partnership (EIP) on raw materials',
    topic: 'Raw materials',
    category: 'Guidance & Implementation Support',
    website: 'single-market-economy.ec.europa.eu',
    url: 'https://single-market-economy.ec.europa.eu/sectors/raw-materials/eip_en'
  },
  {
    id: 39,
    title: 'EU Environmental Technology Verification (ETV)',
    topic: 'Climate, Environment',
    category: 'Guidance & Implementation Support',
    website: 'green-forum.ec.europa.eu',
    url: 'https://green-forum.ec.europa.eu/eu-environmental-technology-verification_en'
  },
  {
    id: 40,
    title: 'The EU Construction & Demolition Waste Management Protocol (2024 updated edition)',
    topic: 'Construction and demolition waste',
    category: 'Guidance & Implementation Support',
    website: 'build-up.ec.europa.eu',
    url:
      'https://build-up.ec.europa.eu/en/resources-and-tools/publications/eu-construction-demolition-waste-management-protocol-2024-updated'
  },
  {
    id: 41,
    title: 'RoHS Directive implementation',
    topic: 'Hazardous waste',
    category: 'Guidance & Implementation Support',
    website: 'environment.ec.europa.eu',
    url: 'https://environment.ec.europa.eu/topics/waste-and-recycling/rohs-directive/rohs-directive-implementation_en'
  },
  {
    id: 42,
    title: 'Implementation of the WEEE Directive',
    topic: 'Electrical and electronic waste',
    category: 'Guidance & Implementation Support',
    website: 'environment.ec.europa.eu',
    url:
      'https://environment.ec.europa.eu/topics/waste-and-recycling/waste-electrical-and-electronic-equipment-weee/implementation-weee-directive_en'
  },
  {
    id: 43,
    title: '3rd Raw Materials Scoreboard European innovation partnership on raw materials',
    topic: 'Raw materials',
    category: 'Guidance & Implementation Support',
    website: 'op.europa.eu',
    url: 'https://op.europa.eu/en/publication-detail/-/publication/eb052a18-c1f3-11eb-a925-01aa75ed71a1/language-en'
  },
  {
    id: 44,
    title: 'Circular procurement in Europe: handbook for local and regional governments',
    topic: 'Green Procurement',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/circular-procurement-europe-handbook-local-and-regional-governments'
  },
  {
    id: 45,
    title: 'Bio-waste circular toolkit for local and regional governments',
    topic: 'Food waste, bio waste',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/bio-waste-circular-toolkit-local-and-regional-governments'
  },
  {
    id: 46,
    title: 'The circular bio-waste management handbook for local authorities',
    topic: 'Food waste, bio waste',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/circular-bio-waste-management-handbook-local-authorities'
  },
  {
    id: 47,
    title: 'CDW circular toolkit for local and regional governments',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/cdw-circular-toolkit-local-and-regional-governments'
  },
  {
    id: 48,
    title: 'Circular construction in Europe: handbook for local and regional governments',
    topic: 'Construction and demolition waste',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/circular-construction-europe-handbook-local-and-regional-governments'
  },
  {
    id: 49,
    title: 'Circular Public Procurement in Cities',
    topic: 'Green Procurement',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/circular-public-procurement-cities'
  },
  {
    id: 50,
    title: 'DEFINITE-CCRI Circularity Tool',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/definite-ccri-circularity-tool'
  },
  {
    id: 51,
    title: 'Circular consumption in cities',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/circular-consumption-cities'
  },
  {
    id: 52,
    title: 'A guide for circularity in the urban built environment',
    topic: 'Construction and demolition waste',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/guide-circularity-urban-built-environment'
  },
  {
    id: 53,
    title: 'A guide for developing a circular city strategy',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/guide-developing-circular-city-strategy'
  },
  {
    id: 54,
    title: 'HOOP Toolkit: designed to unlock investment in the urban bioeconomy',
    topic: 'Sustainability',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/hoop-toolkit-designed-unlock-investment-urban-bioeconomy'
  },
  {
    id: 55,
    title: 'FutuRaM | Future Availability of Raw Materials',
    topic: 'Raw materials',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/futuram-future-availability-raw-materials'
  },
  {
    id: 56,
    title: 'Procurement Transformation Workshop Manual: rethink your procurement processes towards circularity',
    topic: 'Green Procurement',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/procurement-transformation-workshop-manual-rethink-your-procurement-processes-towards-circularity'
  },
  {
    id: 57,
    title: 'Interreg NSR ProCirc : a comprehensive circular procurement toolbox',
    topic: 'Green Procurement',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/interreg-nsr-procirc-comprehensive-circular-procurement-toolbox'
  },
  {
    id: 58,
    title: 'Local stakeholder board meeting? Learn from the Biowaste Club with this Playbook',
    topic: 'Food waste, bio waste',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/local-stakeholder-board-meeting-learn-biowaste-club-playbook'
  },
  {
    id: 59,
    title: 'Stimulating demand for circular construction skills - a guide for public authorities',
    topic: 'Construction and demolition waste',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/stimulating-demand-circular-construction-skills-guide-public-authorities'
  },
  {
    id: 60,
    title: 'A Circular Economy Competence Framework for Young People',
    topic: 'Education of Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/circular-economy-competence-framework-young-people'
  },
  {
    id: 61,
    title: 'Manual for practitioners - Methods and Tools to use the CESCY Framework of Competences',
    topic: 'Education of Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/manual-practitioners-methods-and-tools-use-cescy-framework-competences'
  },
  {
    id: 62,
    title: 'Recommendations for Circular Economy Implementation: Engaging Youth in the Transition',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/recommendations-circular-economy-implementation-engaging-youth-transition'
  },
  {
    id: 63,
    title: 'A Toolbox for Circular Packaging in the Retail sector',
    topic: 'Packaging waste',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/toolbox-circular-packaging-retail-sector'
  },
  {
    id: 64,
    title: 'Incentives to boost the Circular Economy - A guide for Public Authorities',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/incentives-boost-circular-economy-guide-public-authorities'
  },
  {
    id: 65,
    title: 'Cross-KIC Circular Economy System Maps',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/cross-kic-circular-economy-system-maps'
  },
  {
    id: 66,
    title: 'Guidance for evaluating waste prevention programmes',
    topic: 'Waste management',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/guidance-evaluating-waste-prevention-programmes'
  },
  {
    id: 67,
    title: 'Circular Economy in Travel and Tourism: a guide for operators and policymakers',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/circular-economy-travel-and-tourism-guide-operators-and-policymakers'
  },
  {
    id: 68,
    title: 'An EIB Circular Economy Guide on how to support the circular transition',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/eib-circular-economy-guide-how-support-circular-transition'
  },
  {
    id: 69,
    title: 'Sustainable construction guidelines for public authorities – A circular economy perspective',
    topic: 'Construction and demolition waste',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/sustainable-construction-guidelines-public-authorities-circular-economy-perspective'
  },
  {
    id: 70,
    title: 'A new web-portal to help cities become circular: the Circular City Funding Guide',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/new-web-portal-help-cities-become-circular-circular-city-funding-guide'
  },
  {
    id: 71,
    title:
      'Making the Circular Economy Work - MiW-IMPEL Guidance for regulators on enabling innovations for the circular economy',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/making-circular-economy-work-miw-impel-guidance-regulators-enabling-innovations-circular-economy'
  },
  {
    id: 72,
    title: 'ESPON: Policy Guide on Circular Economy and Territorial Consequences (CIRCTER)',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/espon-policy-guide-circular-economy-and-territorial-consequences-circter'
  },
  {
    id: 73,
    title: 'EU guidelines on food donation',
    topic: 'Food waste, bio waste',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/eu-guidelines-food-donation'
  },
  {
    id: 74,
    title: 'Sector-wide Circularity Assessment - construction',
    topic: 'Construction and demolition waste',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/measuring-circular-economy/sector-wide-circularity-assessment-construction'
  },
  {
    id: 75,
    title: 'Urban Circularity Assessment',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/measuring-circular-economy/urban-circularity-assessment'
  },
  {
    id: 76,
    title: 'Sector-wide Circularity Assessment - biomass',
    topic: 'Food waste, bio waste',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/measuring-circular-economy/sector-wide-circularity-assessment-biomass'
  },
  {
    id: 77,
    title: 'Circular economy: New tool for measuring progress',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/measuring-circular-economy/circular-economy-new-tool-measuring-progress'
  },
  {
    id: 78,
    title: 'European Investment Fund (EIF)',
    topic: 'Circular Economy',
    category: 'Financing Environment & Support Mechanisms',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/financing/european-investment-fund-eif'
  },
  {
    id: 79,
    title: 'European Circular Bioeconomy Fund (ECBF)',
    topic: 'Circular Economy',
    category: 'Financing Environment & Support Mechanisms',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/financing/european-circular-bioeconomy-fund-ecbf'
  },
  {
    id: 80,
    title: 'Circular City Funding Guide',
    topic: 'Circular Economy',
    category: 'Financing Environment & Support Mechanisms',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/financing/circular-city-funding-guide'
  },
  {
    id: 81,
    title: 'Circular economy: Overview 2024',
    topic: 'Circular Economy',
    category: 'Financing Environment & Support Mechanisms',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/circular-economy-overview-2024'
  },
  {
    id: 82,
    title: 'The EIB circular economy guide - Supporting the circular transition',
    topic: 'Circular Economy',
    category: 'Financing Environment & Support Mechanisms',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/financing/eib-circular-economy-guide-supporting-circular-transition'
  },
  {
    id: 83,
    title: 'Cohesion Policy',
    topic: 'Sustainability',
    category: 'Financing Environment & Support Mechanisms',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/financing/cohesion-policy'
  },
  {
    id: 84,
    title: 'EU SWITCH to Green flagship initiative',
    topic: 'Circular Economy',
    category: 'Financing Environment & Support Mechanisms',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/financing/eu-switch-green-flagship-initiative'
  },
  {
    id: 85,
    title: 'Single Market Programme',
    topic: 'Food waste, bio waste',
    category: 'Financing Environment & Support Mechanisms',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/financing/single-market-programme'
  },
  {
    id: 86,
    title: 'LIFE programme',
    topic: 'Climate, Environment',
    category: 'Financing Environment & Support Mechanisms',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/financing/life-programme'
  },
  {
    id: 87,
    title: 'Horizon Europe',
    topic: 'Sustainability',
    category: 'Financing Environment & Support Mechanisms',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/financing/horizon-europe'
  },
  {
    id: 88,
    title:
      'REPORT FROM THE COMMISSION TO THE EUROPEAN PARLIAMENT, THE COUNCIL, THE EUROPEAN ECONOMIC AND SOCIAL COMMITTEE AND THE COMMITTEE OF THE REGIONS on the implementation of Directive 2006/21/EC on the management of waste from extractive industries and amending Directive 2004/35/EC',
    topic: 'Waste management',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'eur-lex.europa.eu',
    url: 'https://eur-lex.europa.eu/legal-content/en/TXT/?uri=CELEX:52016DC0553'
  },
  {
    id: 89,
    title:
      'REPORT FROM THE COMMISSION TO THE EUROPEAN PARLIAMENT, THE COUNCIL, THE EUROPEAN ECONOMIC AND SOCIAL COMMITTEE AND THE COMMITTEE OF THE REGIONS on the implementation of EU waste legislation, including the early warning report for Member States at risk of missing the 2020 preparation for re-use/recycling target on municipal waste',
    topic: 'Municipal waste',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'eur-lex.europa.eu',
    url: 'https://eur-lex.europa.eu/legal-content/EN/TXT/?qid=1537873850842&uri=COM:2018:656:FIN'
  },
  {
    id: 90,
    title:
      'COMMISSION STAFF WORKING DOCUMENT Evaluation of Regulation (EU) No 1257/ 2013 of the European Parliament and of the Council of 20 November 2013 on ship recycling and amending Regulation (EC) No 1013/2006 and Directive 2009/16/EC Accompanying the document Report from the Commission to the Council and the European Parliament on the application of Regulation (EU) No 1257/2013 of the European Parliament and of the Council of 20 November 2013 on ship recycling and amending Regulation (EC) No 1013/2006 and Directive 2009/16/EC',
    topic: 'Waste management',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'eur-lex.europa.eu',
    url: 'https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=SWD%3A2025%3A40%3AFIN&qid=1739974658693'
  },
  {
    id: 91,
    title:
      'REPORT FROM THE COMMISSION TO THE COUNCIL AND THE EUROPEAN PARLIAMENT on the application of Regulation (EU) No 1257/2013 of the European Parliament and of the Council of 20 November 2013 on ship recycling and amending Regulation (EC) No 1013/2006 and Directive 2009/16/EC',
    topic: 'Waste management',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'eur-lex.europa.eu',
    url: 'https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=COM%3A2025%3A52%3AFIN&qid=1739974555927'
  },
  {
    id: 92,
    title: 'Support to the evaluation of the Sewage Sludge Directive',
    topic: 'Water',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'op.europa.eu',
    url: 'https://op.europa.eu/en/publication-detail/-/publication/2fd1f88a-438e-11ed-92ed-01aa75ed71a1/language-en'
  },
  {
    id: 93,
    title:
      'REPORT FROM THE COMMISSION TO THE EUROPEAN PARLIAMENT, THE COUNCIL, THE EUROPEAN ECONOMIC AND SOCIAL COMMITTEE AND THE COMMITTEE OF THE REGIONS on the implementation of EU waste legislation, including the early warning report for Member States at risk of missing the 2020 preparation for re-use/recycling target on municipal waste',
    topic: 'Waste management',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'www.europarl.europa.eu',
    url:
      'https://www.europarl.europa.eu/RegData/docs_autres_institutions/commission_europeenne/com/2025/0017/COM_COM(2025)0017_EN.pdf'
  },
  {
    id: 94,
    title: 'Study on socioeconomic impacts of increased reparability of increased reparability',
    topic: 'Waste management',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'op.europa.eu',
    url: 'https://op.europa.eu/en/publication-detail/-/publication/c6865b39-2628-11e6-86d0-01aa75ed71a1'
  },
  {
    id: 95,
    title: 'Preventing waste in Europe - Progress and challenges, with a focus on food waste',
    topic: 'Waste management',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'www.eea.europa.eu',
    url:
      'https://www.eea.europa.eu/en/analysis/publications/preventing-waste-in-europe-progress-and-challenges-with-a-focus-on-food-waste'
  },
  {
    id: 96,
    title: 'Circularity of the EU textiles value chain in numbers',
    topic: 'Fashion, textile',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'www.eea.europa.eu',
    url: 'https://www.eea.europa.eu/en/analyTsis/publications/circularity-of-the-eu-textiles-value-chain-in-numbers'
  },
  {
    id: 97,
    title: 'Product lifespans — monitoring trends in Europe',
    topic: 'Circular Economy',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'www.eea.europa.eu',
    url: 'https://www.eea.europa.eu/en/analysis/publications/product-lifespans-monitoring-trends'
  },
  {
    id: 98,
    title: 'Europe’s circular economy in facts and figures',
    topic: 'Circular Economy',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'www.eea.europa.eu',
    url: 'https://www.eea.europa.eu/en/analysis/publications/europes-circular-economy-in-facts'
  },
  {
    id: 99,
    title: 'Measuring the quality of recycling',
    topic: 'Waste management',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'www.eea.europa.eu',
    url: 'https://www.eea.europa.eu/en/analysis/publications/measuring-the-quality-of-recycling'
  },
  {
    id: 100,
    title: 'The European Environment Agency in brief',
    topic: 'Climate, Environment',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'www.eea.europa.eu',
    url: 'https://www.eea.europa.eu/en/analysis/publications/the-european-environment-agency-in-brief'
  },
  {
    id: 101,
    title: 'The role of plastics in Europe’s circular economy',
    topic: 'Plastic waste',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'www.eea.europa.eu',
    url: 'https://www.eea.europa.eu/en/analysis/publications/the-role-of-plastics-in-europes'
  },
  {
    id: 102,
    title: 'Accelerating the circular economy in Europe',
    topic: 'Circular Economy',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'www.eea.europa.eu',
    url: 'https://www.eea.europa.eu/en/analysis/publications/accelerating-the-circular-economy'
  },
  {
    id: 103,
    title:
      'Capturing the climate change mitigation benefits of circular economy and waste sector policies and measures',
    topic: 'Climate, Environment',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'www.eea.europa.eu',
    url:
      'https://www.eea.europa.eu/en/analysis/publications/capturing-the-climate-change-mitigation-benefits-of-circular-economy-and-waste-sector-policies-and-measures'
  },
  {
    id: 104,
    title: 'Tracking waste prevention progress',
    topic: 'Waste management',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'www.eea.europa.eu',
    url: 'https://www.eea.europa.eu/en/analysis/publications/tracking-waste-prevention-progress'
  },
  {
    id: 105,
    title: 'Investigating Europe′s secondary raw material markets',
    topic: 'Raw materials',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'www.eea.europa.eu',
    url: 'https://www.eea.europa.eu/en/analysis/publications/investigating-europes-secondary-raw-material'
  },
  {
    id: 106,
    title: 'Beyond water quality: sewage treatment in a circular economy',
    topic: 'Water',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'www.eea.europa.eu',
    url: 'https://www.eea.europa.eu/en/analysis/publications/beyond-water-quality-sewage-treatment'
  },
  {
    id: 107,
    title: 'Reflecting on green growth',
    topic: 'Sustainability',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'www.eea.europa.eu',
    url: 'https://www.eea.europa.eu/en/analysis/publications/reflecting-on-green-growth'
  },
  {
    id: 108,
    title:
      'Practical guide on how to communicate about the circular economy (Comment bien communiquer sur l’économie circulaire?)French Agency for Ecological Transition and Circul’R have developed this guide',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/practical-guide-how-communicate-about-circular-economy-comment-bien-communiquer-sur-leconomie-circulaire'
  },
  {
    id: 109,
    title: 'The Circular Venture Blueprint: A Guide for Entrepreneurship Support OrganisationsBelgium',
    topic: 'Ecodesign',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/circular-venture-blueprint-guide-entrepreneurship-support-organisations'
  },
  {
    id: 110,
    title: 'National Circularity Assessment Framework for BuildingsUnited Nations',
    topic: 'Construction and demolition waste',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/national-circularity-assessment-framework-buildings'
  },
  {
    id: 111,
    title: 'Additives Sustainability Footprint (ASF) methodItaly',
    topic: 'Plastic waste',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/additives-sustainability-footprint-asf-method'
  },
  {
    id: 112,
    title: 'Circular Business Development Canvas PackAustria Sweden',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/circular-business-development-canvas-pack'
  },
  {
    id: 113,
    title: 'Déployer l’économie circulaire : La construction (Rolling out the circular economy: Construction)France',
    topic: 'Construction and demolition waste',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/deployer-leconomie-circulaire-la-construction-rolling-out-circular-economy-construction'
  },
  {
    id: 114,
    title: 'Standardization Roadmap Circular EconomyGermany',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/standardization-roadmap-circular-economy'
  },
  {
    id: 115,
    title: '30 years of optimum EPR: How to make the best out of itBelgium',
    topic: 'EPR',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/30-years-optimum-epr-how-make-best-out-it'
  },
  {
    id: 116,
    title: 'Building Circularity into Nationally Determined Contributions – A Practical ToolboxUnited Nations',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/building-circularity-nationally-determined-contributions-practical-toolbox'
  },
  {
    id: 117,
    title: 'Guidance on increasing NDC ambitions through circular actionGermany',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/guidance-increasing-ndc-ambitions-through-circular-action'
  },
  {
    id: 118,
    title: 'Pathways to Green Innovation: Acceleration Scenarios for EU ClustersSpain',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/pathways-green-innovation-acceleration-scenarios-eu-clusters'
  },
  {
    id: 119,
    title: 'Second Catalogue of Best Practices in Circular EconomySpain',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/second-catalogue-best-practices-circular-economy'
  },
  {
    id: 120,
    title:
      'CIRCit research project: tools and guides for shifting to the circular economyDenmark Finland Sweden Other Iceland and Norway',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/circit-research-project-tools-and-guides-shifting-circular-economy'
  },
  {
    id: 121,
    title: 'Model clauses for Product-as-a-Service (PaaS) contractsBelgium',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/model-clauses-product-service-paas-contracts'
  },
  {
    id: 122,
    title: 'Policy Toolkit on Municipal Waste Management: A Guide for Decision-Makers in the MediterraneanGreece',
    topic: 'Waste management',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/policy-toolkit-municipal-waste-management-guide-decision-makers-mediterranean'
  },
  {
    id: 123,
    title:
      'IDEA educational materials: helping educators boost the employability of unemployed adults through circular economyItaly',
    topic: 'Education of Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/idea-educational-materials-helping-educators-boost-employability-unemployed-adults-through-circular-economy'
  },
  {
    id: 124,
    title:
      'Fostering circular economy education among the younger generationsItaly Finland Other The Republic of North Macedonia',
    topic: 'Education of Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/fostering-circular-economy-education-among-younger-generations'
  },
  {
    id: 125,
    title: 'Circular Transition Indicators (CTI): sector guidance - electronic devicesSwitzerland',
    topic: 'Electrical and electronic waste',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines?page=3'
  },
  {
    id: 126,
    title: 'Circular solutions for nature - Handbook for businessesFinland',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/circular-solutions-nature-handbook-businesses'
  },
  {
    id: 127,
    title: "GO-GRASS evaluation tool: Unleash Your Grass Project's Potential Now!Belgium",
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/go-grass-evaluation-tool-unleash-your-grass-projects-potential-now'
  },
  {
    id: 128,
    title: 'TwinRevolution: upskilling and reskilling VET learners with green and digital competencesEU Spain',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/twinrevolution-upskilling-and-reskilling-vet-learners-green-and-digital-competences'
  },
  {
    id: 129,
    title: 'Procurement Strategies - Integrating Reuse in Large-Scale Projects and Public ProcurementsBelgium',
    topic: 'Green Procurement',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/procurement-strategies-integrating-reuse-large-scale-projects-and-public-procurements'
  },
  {
    id: 130,
    title: 'Circular Risk ScorecardNetherlands',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/circular-risk-scorecard'
  },
  {
    id: 131,
    title: 'IDEA - Improved Employability through circular economy education for Adults GuidebookItaly',
    topic: 'Education of Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/idea-improved-employability-through-circular-economy-education-adults-guidebook'
  },
  {
    id: 132,
    title: 'Building circularity software for a circular economy: One Click LCAFinland',
    topic: 'Construction and demolition waste',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/building-circularity-software-circular-economy-one-click-lca'
  },
  {
    id: 133,
    title:
      'CE-RISE | Circular Economy Resource Information System | European Circular Economy Stakeholder PlatformBelgium',
    topic: 'Raw materials',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/ce-rise-circular-economy-resource-information-system'
  },
  {
    id: 134,
    title: 'Transform-CE has created a Navigation Tool guiding users through plastic recyclingNetherlands',
    topic: 'Plastic waste',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/transform-ce-has-created-navigation-tool-guiding-users-through-plastic-recycling'
  },
  {
    id: 135,
    title: 'Nordic Circular Economy Playbook 2.0Norway',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/nordic-circular-economy-playbook-20'
  },
  {
    id: 136,
    title: 'WEEE reporting tool by BeWeeeBelgium',
    topic: 'Electrical and electronic waste',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/weee-reporting-tool-beweee'
  },
  {
    id: 137,
    title:
      'The Circular Buildings Toolkit helps embed circular economy principles into new construction projectsUnited Kingdom',
    topic: 'Construction and demolition waste',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/circular-buildings-toolkit-helps-embed-circular-economy-principles-new-construction-projects'
  },
  {
    id: 138,
    title: 'Roadmap Circular Procurement & Commissioning - Towards 100%Netherlands',
    topic: 'Green Procurement',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/roadmap-circular-procurement-commissioning-towards-100'
  },
  {
    id: 139,
    title: 'The environmental impact of building materialsNetherlands',
    topic: 'Construction and demolition waste',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/environmental-impact-building-materials'
  },
  {
    id: 140,
    title: 'The circular design of buildingsNetherlands',
    topic: 'Ecodesign',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/circular-design-buildings'
  },
  {
    id: 141,
    title: 'Close The Loop - A guide towards a circular fashion industryBelgium',
    topic: 'Fashion, textile',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/close-loop-guide-towards-circular-fashion-industry'
  },
  {
    id: 142,
    title:
      'Traceability and Transparency for Sustainable and Circular Garment and Footwear Value Chains | European Circular Economy Stakeholder PlatformSwitzerland, World (United Nations Economic Commission for Europe)',
    topic: 'Sustainability',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/traceability-and-transparency-sustainable-and-circular-garment-and-footwear-value-chains'
  },
  {
    id: 143,
    title:
      'Enterprise Value Chain Carbon Emission Reduction - a practical guide by NormativeDenmark Sweden United Kingdom',
    topic: 'Climate, Environment',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/enterprise-value-chain-carbon-emission-reduction-practical-guide-normative'
  },
  {
    id: 144,
    title: 'Circular public procurement: a framework for citiesUnited Kingdom',
    topic: 'Green Procurement',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/circular-public-procurement-framework-cities'
  },
  {
    id: 145,
    title: 'Tools for developing your circular business modelNetherlands',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/tools-developing-your-circular-business-model'
  },
  {
    id: 146,
    title: 'A Whitepaper on Circular Business ModelsNetherlands',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/whitepaper-circular-business-models'
  },
  {
    id: 147,
    title: 'Transition time! A circular economy for plasticsNetherlands',
    topic: 'Plastic waste',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/transition-time-circular-economy-plastics'
  },
  {
    id: 148,
    title: '10 steps to integrate the circular economy into your purchasing - Operational guidelinesFrance',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/10-steps-integrate-circular-economy-your-purchasing-operational-guidelines'
  },
  {
    id: 149,
    title: 'The Netwap Project: a network of small “in situ” waste prevention and management initiativesItaly',
    topic: 'Waste management',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/netwap-project-network-small-situ-waste-prevention-and-management-initiatives'
  },
  {
    id: 150,
    title: 'Circulab toolbox: apply regenerative economy principlesFrance',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/circulab-toolbox-apply-regenerative-economy-principles'
  },
  {
    id: 151,
    title: 'Organizing for Sustainability: A Guide to Developing New Business ModelsNetherlands',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/organizing-sustainability-guide-developing-new-business-models'
  },
  {
    id: 152,
    title: 'TOTEM: an online tool for architects that calculates the environmental footprint of buildingsBelgium',
    topic: 'Construction and demolition waste',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/totem-online-tool-architects-calculates-environmental-footprint-buildings'
  },
  {
    id: 153,
    title: 'Sustainable healthcare waste management in the EU Circular Economy modelBelgium',
    topic: 'Healthcare waste',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/sustainable-healthcare-waste-management-eu-circular-economy-model'
  },
  {
    id: 154,
    title: 'Circular Procurement GuideUnited Kingdom',
    topic: 'Green Procurement',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/circular-procurement-guide'
  },
  {
    id: 155,
    title: 'E-Learning module on Innovative and Responsible Public ProcurementNetherlands',
    topic: 'Green Procurement',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/e-learning-module-innovative-and-responsible-public-procurement'
  },
  {
    id: 156,
    title:
      'The Circular Toolbox: A step-by-step guide for apparel brands to launch rental and resale business model pilotsNetherlands',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/circular-toolbox-step-step-guide-apparel-brands-launch-rental-and-resale-business-model-pilots'
  },
  {
    id: 157,
    title:
      'Recommendations to national policy-makers on circular public procurementDenmark Finland Latvia Netherlands Poland Sweden Other Russia',
    topic: 'Green Procurement',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/recommendations-national-policy-makers-circular-public-procurement'
  },
  {
    id: 158,
    title: 'Design Research Tools: How to become a more sustainable and circular designerUnited Kingdom',
    topic: 'Ecodesign',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/design-research-tools-how-become-more-sustainable-and-circular-designer'
  },
  {
    id: 159,
    title: 'Circular Procurement in 8 stepsNetherlands',
    topic: 'Green Procurement',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/circular-procurement-8-steps'
  },
  {
    id: 160,
    title: 'Circular Economy Guidebook for CitiesGermany',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/circular-economy-guidebook-cities'
  },
  {
    id: 161,
    title: '6 guidelines to empower financial decision-making in the circular economyNetherlands',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/6-guidelines-empower-financial-decision-making-circular-economy'
  },
  {
    id: 162,
    title: 'Create a financeable circular business in 10 stepsNetherlands',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/create-financeable-circular-business-10-steps'
  },
  {
    id: 163,
    title: 'Building Value: A pathway to circular construction financeNetherlands',
    topic: 'Construction and demolition waste',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/building-value-pathway-circular-construction-finance'
  },
  {
    id: 164,
    title: 'Circular Economy Finance GuidelinesNetherlands',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/circular-economy-finance-guidelines'
  },
  {
    id: 165,
    title: 'Organising for the Circular Economy - A Workbook for Developing Circular Business Models.Netherlands',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/organising-circular-economy-workbook-developing-circular-business-models'
  },
  {
    id: 166,
    title:
      'Guide to Circular and Green Economy in the local world: How to get into action and tools for local entitiesSpain',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/guide-circular-and-green-economy-local-world-how-get-action-and-tools-local-entities'
  },
  {
    id: 167,
    title: 'Delivering the circular economy: a toolkit for policymakersUnited Kingdom',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/delivering-circular-economy-toolkit-policymakers'
  },
  {
    id: 168,
    title: 'Circularise - an open, distributed and secure communications protocol for the circular economyNetherlands',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/circularise-open-distributed-and-secure-communications-protocol-circular-economy'
  },
  {
    id: 169,
    title: 'The circularity rate in the Republic of Moldova 2024Republic of Moldova',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/measuring-circular-economy/circularity-rate-republic-moldova-2024-rata-de-circularitate-republica-moldova-2024'
  },
  {
    id: 170,
    title: 'CircularTracker: a standardised tool for measuring product circularityLuxembourg',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/measuring-circular-economy/circulartracker-standardised-tool-measuring-product-circularity'
  },
  {
    id: 171,
    title:
      'Energy Expert by Alibaba: tracking CO2 performance of rPET production line and providing consumers with easy-to-access informationChina',
    topic: 'Plastic waste',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/measuring-circular-economy/energy-expert-alibaba-tracking-co2-performance-rpet-production-line-and-providing-consumers-easy'
  },
  {
    id: 172,
    title: 'CSRD Tool by Circle EconomyNetherlands',
    topic: 'Sustainability',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/measuring-circular-economy/csrd-tool-circle-economy'
  },
  {
    id: 173,
    title: 'Circularity Assessment ToolNetherlands',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/measuring-circular-economy/circularity-assessment-tool'
  },
  {
    id: 174,
    title: 'Tarkett’s Carbon CalculatorFrance',
    topic: 'Climate, Environment',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/measuring-circular-economy/tarketts-carbon-calculator'
  },
  {
    id: 175,
    title: 'A Circular Benchmark Tool to evaluate the transition to circularity by regionsNetherlands',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/measuring-circular-economy/circular-benchmark-tool-evaluate-transition-circularity-regions'
  },
  {
    id: 176,
    title: 'Normative: the circular economy accelerates the process of meeting Paris Agreement climate targetsSweden',
    topic: 'Climate, Environment',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/measuring-circular-economy/normative-circular-economy-accelerates-process-meeting-paris-agreement-climate-targets'
  },
  {
    id: 177,
    title: 'A Circular Tool by Matrec to measure the product circularity in the design phaseItaly',
    topic: 'Ecodesign',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/measuring-circular-economy/circular-tool-matrec-measure-product-circularity-design-phase'
  },
  {
    id: 178,
    title: 'A Circular Economy Monitor for FlandersBelgium',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/measuring-circular-economy/circular-economy-monitor-flanders'
  },
  {
    id: 179,
    title: 'Circular Metrics for BusinessNetherlands',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url: 'https://circulareconomy.europa.eu/platform/en/measuring-circular-economy/circular-metrics-business'
  },
  {
    id: 180,
    title: 'The Waste management Datacenter by LIPOR monitors waste flowsPortugal',
    topic: 'Waste management',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/measuring-circular-economy/waste-management-datacenter-lipor-monitors-waste-flows-citizens-participation-and-contributes'
  },
  {
    id: 181,
    title: 'Circulytics - a comprehensive circularity measurement toolUnited Kingdom Switzerland',
    topic: 'Circular Economy',
    category: 'Guidance & Implementation Support',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/measuring-circular-economy/circulytics-comprehensive-circularity-measurement-tool'
  },
  {
    id: 182,
    title: 'Life Cycle Assessment study for hospital medical device purchasersGermany',
    topic: 'Healthcare waste',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/toolkits-guidelines/life-cycle-assessment-study-hospital-medical-device-purchasers'
  },
  {
    id: 183,
    title:
      'Sustainability accounting and disclosures of responsible restaurant practices in environmental, social and governance (ESG) reportsMalta United Kingdom Other United States of America',
    topic: 'Sustainability',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/measuring-circular-economy/sustainability-accounting-and-disclosures-responsible-restaurant-practices-environmental-social-and'
  },
  {
    id: 184,
    title: 'Assessing the social impacts of circular strategies in the apparel value chainNetherlands',
    topic: 'Circular Economy',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/measuring-circular-economy/assessing-social-impacts-circular-strategies-apparel-value-chain'
  },
  {
    id: 185,
    title: 'Resources potential - certification beyond recycling ratesLuxembourg',
    topic: 'Waste management',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/measuring-circular-economy/resources-potential-certification-beyond-recycling-rates'
  },
  {
    id: 186,
    title: 'An economy wide circularity assessment in FlandersBelgium',
    topic: 'Circular Economy',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/measuring-circular-economy/economy-wide-circularity-assessment-flanders'
  },
  {
    id: 187,
    title: 'Circular economy indicators for the food systemBelgium',
    topic: 'Food waste, bio waste',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/measuring-circular-economy/circular-economy-indicators-food-system'
  },
  {
    id: 188,
    title: 'Circular economy indicators for buildings and housingBelgium',
    topic: 'Construction and demolition waste',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/measuring-circular-economy/circular-economy-indicators-buildings-and-housing'
  },
  {
    id: 189,
    title: 'Circular economy indicators for consumer goodsBelgium',
    topic: 'Circular Economy',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/measuring-circular-economy/circular-economy-indicators-consumer-goods'
  },
  {
    id: 190,
    title: 'Reuse. The understudied circular economy strategyBelgium',
    topic: 'Circular Economy',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/measuring-circular-economy/reuse-understudied-circular-economy-strategy'
  },
  {
    id: 191,
    title: 'Macro-economic material flow indicators for Flanders 2002-2018Belgium',
    topic: 'Circular Economy',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/measuring-circular-economy/macro-economic-material-flow-indicators-flanders-2002-2018'
  },
  {
    id: 192,
    title: 'Circular economy indicators for person mobility and transportBelgium',
    topic: 'Circular Economy',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/measuring-circular-economy/circular-economy-indicators-person-mobility-and-transport'
  },
  {
    id: 193,
    title: 'Modelling job creation in the circular economy in FlandersBelgium',
    topic: 'Circular Economy',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/measuring-circular-economy/modelling-job-creation-circular-economy-flanders'
  },
  {
    id: 194,
    title: 'New report helps IT buyers avoid greenwash and false claimsSweden',
    topic: 'Sustainability',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/measuring-circular-economy/new-report-helps-it-buyers-avoid-greenwash-and-false-claims'
  },
  {
    id: 195,
    title: "Monitoring progress in Europe's circular economy: the Bellagio ProcessItaly",
    topic: 'Circular Economy',
    category: 'Evidence, Monitoring & Evaluation',
    website: 'circulareconomy.europa.eu',
    url:
      'https://circulareconomy.europa.eu/platform/en/measuring-circular-economy/monitoring-progress-europes-circular-economy-bellagio-process'
  }
]
